var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgSliderMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.836,
    height: 12.138,
    viewBox: "0 0 14.836 12.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.487 8.092h1.349v1.349h-1.349zm0-2.7h1.349v1.352h-1.349zm1.349 5.395h-1.349v1.349a1.45 1.45 0 001.349-1.346zM8.092 0h1.349v1.349H8.092zm5.395 2.7h1.349v1.346h-1.349zm0-2.7v1.349h1.349A1.45 1.45 0 0013.487 0zM0 2.7h1.349v1.346H0zM10.79 0h1.349v1.349H10.79zm0 10.79h1.349v1.349H10.79zM1.349 0A1.45 1.45 0 000 1.349h1.349zm4.046 0h1.349v1.349H5.395zM2.7 0h1.346v1.349H2.7zM0 5.395v5.395a1.353 1.353 0 001.349 1.349h8.092V5.395zm1.349 5.395l1.686-2.165 1.207 1.45L5.928 7.9l2.164 2.89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSliderMin);
export default __webpack_public_path__ + "static/media/img-slider-min.d5739cdd.svg";
export { ForwardRef as ReactComponent };